import { flow } from "mobx";
import { Instance, types } from "mobx-state-tree";
import { ICalendarMeeting } from "./CalendarMeeting";
import { logger } from "@fidget/common/utils";
import { servicesGetters } from "../utils";

export enum Trash {
  HIDDEN = "HIDDEN",
  PROMPT = "PROMPT", // trash is visible and accepts drops
  UNDO = "UNDO" // trash keeps the last removed meeting waiting for undelete operation
}

class DeletedMeeting {
  duration: number;
  start: number;
  roomId: string;
  guestDisplayName?: string;
  constructor(meeting: ICalendarMeeting) {
    this.duration = meeting.duration;
    this.start = meeting.start;
    this.roomId = meeting.roomId;
  }
}

export const CalendarTrash = types
  .model("CalendarTrash", {
    meeting: types.maybe(types.frozen<DeletedMeeting>()),
    state: types.optional(types.enumeration("trashStatuses", Object.values(Trash)), Trash.HIDDEN)
  })
  .views(servicesGetters)
  .actions((self) => ({
    hide() {
      self.meeting = undefined;
      self.state = Trash.HIDDEN;
    },
    prompt() {
      self.meeting = undefined;
      self.state = Trash.PROMPT;
    },
    undo(candidate: ICalendarMeeting) {
      self.meeting = new DeletedMeeting(candidate);
      self.state = Trash.UNDO;
    }
  }))
  .actions((self) => ({
    undeleteMeeting: flow(function* () {
      const meeting = self.meeting;
      if (meeting) {
        try {
          yield self.spinnerService.scheduleMeeting(
            meeting.roomId,
            meeting.start,
            meeting.duration
          );
          self.hide();
        } catch (error) {
          logger.error({ message: "Couldn't schedule meeting", error });
          throw new Error("Could not schedule the meeting");
        }
      }
    })
  }));

export type ICalendarTrash = Instance<typeof CalendarTrash>;
